/**
 * 検索クエリ取得
 * formItems に定義されたフォーム項目名一覧をもとに、一致する入力項目を所定のFormから抽出し、
 * jQueryオブジェクトに収集し、serialize()により取得したクエリ文字列を返す
 */
function getSearch(formSelector, ignoreName)
{
  // 初期化
  if (ignoreName === undefined) {
    ignoreName = [];
  }

  // 検索条件
  var $search = $();

  formItems.forEach(function(name) {
    if (ignoreName.indexOf(name) !== -1) {
      return;
    }

    // フォーム項目 取得
    var $formItem = $('[name="' + name + '"],[name="' + name + '[]"]', formSelector);
    if ($formItem.length === 0) {
      return;
    }

    // フォーム属性 取得
    var type = $formItem.attr("type");

    // ラジオ、チェックボックス フィルタ
    if (type === "radio" || type === "checked") {
      $formItem = $formItem.filter(":checked");
    }

    // 未入力のテキスト／ラジオは送信しない
    if ((type === "text" || type === "radio") && ($formItem.val() === "")) {
      return;
    }

    // 未入力の新規hiddenは送信しない
    var get = getUrlVars();
    if (type === "hidden" && $formItem.val() === "" && !(name in get)) {
      return;
    }

    // --------------------------
    // 個別処理
    // --------------------------

    // 専有面積
    if (name === 'room_size_min' || name === 'room_size_max') {
      // 直接入力優先
      var delIndex = formItems.indexOf("room_size_radio");
      if (delIndex !== -1) {
        formItems.splice(delIndex, 1);
      }
    }

    // 専有面積ラジオ
    if (name === 'room_size_radio') {
      // 送信用に分解
      var vals = $formItem.val().split(',');
      $search = $search.add($("<input>", {"name": "room_size_min", "value": vals[0]}));
      $search = $search.add($("<input>", {"name": "room_size_max", "value": vals[1]}));
      return;
    }

	// 販売価格ラジオ
    if (name === 'price_radio') {
		// 送信用に分解
		var vals = $formItem.val().split(',');
		$search = $search.add($("<input>", {"name": "price_min", "value": vals[0]}));
		$search = $search.add($("<input>", {"name": "price_max", "value": vals[1]}));
		return;
	  }

	// 賃貸ラジオ
    if (name === 'rent_radio') {
		// 送信用に分解
		var vals = $formItem.val().split(',');
		$search = $search.add($("<input>", {"name": "rent_min", "value": vals[0]}));
		$search = $search.add($("<input>", {"name": "rent_max", "value": vals[1]}));
		return;
	  }

    // 建物ソートの未指定は送信しない
    if ((name === 'sort_type' || name === 'sort_direction') && ($formItem.val() === "")) {
      return;
    }

    // 検索条件へ追加
    $search = $search.add($formItem);
  });

  // 検索クエリ
  return $search.serialize();
}
